import { Grid, GridItem } from "@chakra-ui/react";

import { CheckboxGroup } from "../../checkbox/checkbox";

import { Checkbox } from "../../checkbox/checkbox";
import { Textarea } from "../../textarea/textarea";

import { QuestionWithHeaderAndFooter } from "../question";
import { buildImgixUrl } from "@/lib";

import { QuestionContent } from "../question-content";
import { CheckboxQuestionProps } from "../types";

export const CheckboxQuestion = (props: CheckboxQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    contentLayoutProps,
    layoutProps,
    answer,
    checkboxAnswerLimit,
    size,
    minImageWidth = 300,
    disabled,
    handleChange,
    answerStackSpacing,
    options,
    showTextAnswer,
    otherAnswer,
    otherAnswerClassName,
    otherAnswerSize,
    otherAnswerProps,
    isHorizontal,
    handleOtherAnswer,
    answerProps,
    getCheckboxOptionDataTestId,
    checkboxOtherTextDataTestId,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    questionId,
    layoutProps,
    questionLabel,
    questionLabelType,
    labelClassName,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent {...contentLayoutProps}>
        <CheckboxGroup onValueChange={handleChange} value={answer.map(String)}>
          <Grid
            templateColumns={{
              lg: isHorizontal ? `repeat(auto-fill, ${minImageWidth}px)` : "1fr"
            }}
            alignItems="baseline"
            gap={answerStackSpacing}
          >
            {options &&
              options
                .filter((option) => !option.supportsTextAnswer)
                .map((option) => (
                  <GridItem
                    key={option.id}
                    css={{
                      "@-moz-document url-prefix()": {
                        alignSelf: "normal"
                      }
                    }}
                  >
                    <Checkbox
                      required={false}
                      invalid={false}
                      value={`${option.id}`}
                      imageSrc={buildImgixUrl(option.imageUrl)}
                      imageAlt={option.imageAltText || option.name}
                      disabled={
                        answer?.length === checkboxAnswerLimit &&
                        !(answer.indexOf(option.id) > -1)
                      }
                      minH={{ base: "44px", lg: "auto" }}
                      size={size}
                      {...answerProps}
                      data-testid={getCheckboxOptionDataTestId?.(option)}
                    >
                      {option.name}
                    </Checkbox>
                  </GridItem>
                ))}
          </Grid>
          {options &&
            options
              .filter((option) => option.supportsTextAnswer)
              .map((option) => (
                <Checkbox
                  key={option.id}
                  required={false}
                  invalid={false}
                  mt={answerStackSpacing}
                  value={`${option.id}`}
                  imageSrc={buildImgixUrl(option.imageUrl)}
                  imageAlt={option.imageAltText || option.name}
                  disabled={
                    answer?.length === checkboxAnswerLimit &&
                    !(answer.indexOf(option.id) > -1)
                  }
                  size={size}
                  {...answerProps}
                  data-testid={getCheckboxOptionDataTestId?.(option)}
                >
                  {option.name}
                </Checkbox>
              ))}
        </CheckboxGroup>
        {showTextAnswer && (
          <Grid templateColumns="repeat(12, 1fr)">
            <GridItem colSpan={{ base: 12, lg: 10, "2xl": 4 }}>
              <Textarea
                mt={2}
                required
                aria-label={showTextAnswer.name}
                disabled={disabled}
                value={otherAnswer}
                onChange={handleOtherAnswer}
                className={otherAnswerClassName}
                size={otherAnswerSize}
                {...otherAnswerProps}
                data-testid={checkboxOtherTextDataTestId}
              />
            </GridItem>
          </Grid>
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
